import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.scss']
})
export class SuccessModalComponent implements OnInit  {

  public onClose: Subject<boolean> = new Subject();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {


  }

  closeModal() {
    this.activeModal.close();
  }


}
